module.exports = __webpack_public_path__ + "static/logo-trees-for-future-green.574ad62e.png";